import React from "react";
import Layout from "../../../Layout";
import HeaderReports from "../../HeaderReports";
import ListUserActivity from "./ListUserActivity";
import SearchUserActivity from "./SearchUserActivity";

const UserActivity = () => {

  return (
    <Layout>
      <HeaderReports />
      <ListUserActivity />
      <SearchUserActivity />
    </Layout>
  );
};


export default UserActivity;
